import React from "react"
import PropTypes from 'prop-types'

import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";

const debug = false
// const debug = "MultiselectActionForm"

export default class FieldMultiselect_AutomationActionForm extends React.Component<FieldAutomationActionFormProps, any> {

    static propTypes = {
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', null),
        }
    }

    onChangeToValue = (toValue:any) => {
        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <div className="flex-row-left-top">
                <div className="label w-100">to</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {this.props.field.getAutomationOptions()}
                                       values                           = {this.state.toValue}
                                       allValuesOptionLabel             = "None"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeToValue}/>
            </div>
        )
    }
}
